import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "68",
  height: "68",
  fill: "none",
  viewBox: "0 0 68 68"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "67",
      height: "67",
      x: ".5",
      y: ".5",
      stroke: "currentColor",
      rx: "33.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M43.334 37.917a.75.75 0 0 1 .75.75v3.167a2.25 2.25 0 0 1-2.25 2.25H26.166a2.25 2.25 0 0 1-2.25-2.25v-3.167a.75.75 0 0 1 1.5 0v3.167c0 .414.336.75.75.75h15.668c.414 0 .75-.336.75-.75v-3.167a.75.75 0 0 1 .75-.75m-9.333-14c.223 0 .42.099.558.253l5.366 5.361a.751.751 0 0 1-1.004 1.114l-.057-.052-4.113-4.113v12.187a.75.75 0 0 1-1.5 0v-12.19l-4.118 4.116-.057.052a.751.751 0 0 1-1.055-1.056l.051-.058 5.397-5.391.01-.01a1 1 0 0 1 .09-.074l.012-.01a.75.75 0 0 1 .42-.129"
    }, null, -1)
  ]))]))
}
export default { render: render }